// For user
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT'
export const DELETE_PRODUCT = 'DELETE_PRODUCT'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'
export const USER_LOADED = 'USER_LOADED'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'
export const TIMEOUT = 'TIMEOUT'
export const PROFILE_TIMEOUT = 'PROFILE_TIMEOUT'
export const SET_USER_ROLE = 'SET_USER_ROLE'

// For vendors
export const GET_CONTACTS = 'GET_CONTACTS'
export const SET_CONTACTS = 'SET_CONTACTS'
export const GET_VENDORS = 'GET_VENDORS'
export const SET_VENDORS = 'SET_VENDORS'
export const SET_CURRENT_CONTACT = 'SET_CURRENT_CONTACT'
export const SET_CURRENT_VENDOR = 'SET_CURRENT_VENDOR'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const UPDATE_VENDOR = 'UPDATE_VENDOR'

// For alerts
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const SET_ALERT = 'SET_ALERT'
export const REMOVE_ALERT = 'REMOVE_ALERT'

// For product submissions
export const SET_CURRENT_SUBMIT = 'SET_CURRENT_SUBMIT'
export const DELETE_PRODUCT_SUBMIT = 'DELETE_PRODUCT_SUBMIT'
export const ADD_PRODUCT_SUBMIT = 'ADD_PRODUCT_SUBMIT'
export const GET_PRODUCTS_SUBMIT = 'GET_PRODUCTS_SUBMIT'
export const EDIT_PRODUCT_SUBMIT = 'EDIT_PRODUCT_SUBMIT'
export const UPDATE_PRODUCT_SUBMIT = 'UPDATE_PRODUCT_SUBMIT'
export const SET_UPDATE_SUBMIT = 'SET_UPDATE_SUBMIT'
export const CLEAR_CURRENT_SUBMIT = 'CLEAR_CURRENT_SUBMIT'
export const FILTER_PRODUCTS_SUBMIT = 'FILTER_PRODUCTS_SUBMIT'
export const CLEAR_FILTER_SUBMIT = 'CLEAR_FILTER_SUBMIT'
export const LOAD_IMAGES_SUBMIT = 'LOAD_IMAGES_SUBMIT'
export const REPLACE_PRODUCT_SUBMIT = 'REPLACE_PRODUCT_SUBMIT'
export const SET_RESETTING_SUBMIT = 'SET_RESETTING_SUBMIT'
export const SUBMIT_PRODUCTS_SUBMIT = 'SUBMIT_PRODUCTS_SUBMIT'

// For product review
export const GET_SUBMITTED_PRODUCTS = 'GET_SUBMITTED_PRODUCTS'
export const GET_IN_REVIEW_PRODUCTS = 'GET_IN_REVIEW_PRODUCTS'
export const GET_APPROVED_REJECTED_PRODUCTS = 'GET_APPROVED_REJECTED_PRODUCTS'
export const CLEAR_CURRENT_PRODUCT = 'CLEAR_CURRENT_PRODUCT'
export const UPDATE_CURRENT_PRODUCT = 'UPDATE_CURRENT_PRODUCT'
export const REPLACE_CURRENT_PRODUCT = 'REPLACE_CURRENT_PRODUCT'
export const ADD_CURRENT_PRODUCT = 'ADD_CURRENT_PRODUCT'
export const DELETE_CURRENT_PRODUCT = 'DELETE_CURRENT_PRODUCT'
export const SET_SAVING = 'SET_SAVING'
// For pages
export const SET_SCROLL_TO_TOP = 'SET_SCROLL_TO_TOP'
